<template>
	<div>
		<vx-tooltip text="Download pdf">
			<vs-button id="downloadLabelPdfButton" class="vs-con-loading__container" color="primary" @click.native="selectedDownloadAddressLabelPdf">
				<font-awesome-icon :icon="['fas', 'file-pdf']" class="fa-icon"/>
			</vs-button>
		</vx-tooltip>
	</div>
</template>

<script>
import apiClient from "../../services/apiClient";
import {format} from "date-fns";

export default {
	props: {
		order: {
			required: true,
			type: Object,
		},
	},
	methods: {
		selectedDownloadAddressLabelPdf() {
			this.startLoading();

			apiClient.get('orders/a6AddressLabel/download', {
				params: {'order_id': this.order.order.id},
				responseType: 'blob'
			}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', 'adreslabel-' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopLoading();
			}).catch(error => {
				console.log(error);

				this.stopLoading();
			})
		},
		startLoading() {
			this.$vs.loading({
				container: '#downloadLabelPdfButton',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#downloadLabelPdfButton > .con-vs-loading')
		}
	}
}
</script>
